import { render, staticRenderFns } from "./webviewAdapterFile.vue?vue&type=template&id=dcef1f5c&scoped=true"
import script from "./webviewAdapterFile.vue?vue&type=script&lang=js"
export * from "./webviewAdapterFile.vue?vue&type=script&lang=js"
import style0 from "./webviewAdapterFile.vue?vue&type=style&index=0&id=dcef1f5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcef1f5c",
  null
  
)

export default component.exports